module.exports = __webpack_public_path__ + "img/hero2.63a2742d.webp";